











































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import Miembro from "@/models/miembro/miembro.model";
import BTableColumn from "@/models/base/BTableColumn.model";
import GenericBTable from "@/core/Generics/GenericBTable";
import { BTableColumnType } from "@/enums/BTableColumnType";
import Helpers from "@/helpers/helper";
import moment from "moment";
import { AxiosResponse } from "axios";
import MiembroAdd from "./add.vue";
import Persona from "@/models/persona/persona.model";
import { RowTable } from "@/typings/BRowTable";
import { TipoTramiteCode } from "@/enums/TipoTramiteCode";

@Component
export default class MiembroTable extends GenericBTable<Miembro> {
  @Prop() public controller!: string;
  @Prop() public action!: string;
  @Prop() public codigoHogar!: string;
  @Prop() public hogarId!: number;
  @Prop() public excluirJefe!: boolean;
  @Prop() public excluidos!: boolean;

  @Prop() public aggregable!: boolean;
  @Prop() public editable!: boolean;
  @Prop() public selectable!: boolean;
  @Prop() public checkable!: boolean;
  @Prop() public title!: string;
  @Prop() public hideHeader!: string;
  @Prop() public tramiteCode!: TipoTramiteCode;
  @Prop({ default: false }) public loadingModalAdd!: boolean;

  miembros: Miembro[] = [];
  data: Miembro[] = [];

  searchCriteria: string = String();

  getFoto(value: string) {
    return `data:image/jpg;base64, ${value}`;
  }

  created() {
    this.tableConfig.controller = this.controller || "miembro";
    this.tableConfig.include =
      "Hogar|Persona|Parentesco|Persona.CentroAcademico|Persona.TipoDiscapacidad";
    this.tableConfig.selectable = this.selectable;
    this.tableConfig.checkable = this.checkable;
    this.tableConfig.activeActions = this.editable;

    if (this.editable) {
      this.tableConfig.actions.showRemove = false;
      this.tableConfig.actions.edit = this.showModalEditMiembro;
    }

    this.tableConfig.whereParams = this.getWhereParams();

    this.tableConfig.loading = false;
    this.tableConfig.enableDefaultColumns = false;
    this.formatColumns();
  }
  get cleanSearchCriteria() {
    if (this.searchCriteria) return this.searchCriteria.replace(/-/g, "");
    return "";
  }
  searchByDescription() {
    this.tableConfig.whereParams = this.getWhereParams();
    this.tableConfig.reload();
  }
  getPersona(
    id: number,
    nombre: string,
    cedula: string,
    foto: string,
    model: Persona
  ) {
    let persona = model || new Persona();
    persona.id = id;
    persona.nombreCompleto = nombre;
    persona.cedula = cedula;
    persona.foto = foto;
    return persona;
  }

  get isMobile() {
    return this.$store.state.isMobile;
  }

  getWhereParams() {
    let result = [];
    if (this.codigoHogar) result.push(`codigoHogar="${this.codigoHogar}"`);
    else if (this.hogarId) result.push(`hogarId=${this.hogarId}`);

    if (this.searchCriteria)
      result.push(`persona.cedula="${this.cleanSearchCriteria}"`);
      if(this.excluidos === false || this.excluidos ===  true)
       result.push(`excluido=${this.excluidos}`);

    return result.join("&");
  }

  formatColumns() {
    let persona = new BTableColumn(
      "personaId",
      this.isMobile ? "Nombre" : "Nombre completo"
    );
    persona.customTemplate = true;
    persona.templateSlot = "persona";
    //let nombre = new BTableColumn("persona.nombreCompleto", "Nombre", false);
    let cedula = new BTableColumn("persona.cedula", "Cédula");
    cedula.type = BTableColumnType.Custom;
    cedula.customFilter = Helpers.Filters.Cedula;
    cedula.customTemplate = true;
    cedula.templateSlot = "cedula";
    let edad = new BTableColumn("persona.fechaNacimiento", "Edad");
    edad.type = BTableColumnType.Custom;
    edad.customFilter = Helpers.Filters.EdadText;
     let fechaNacimiento = new BTableColumn("persona.fechaNacimiento", "Fecha nacimiento");
     fechaNacimiento.type = BTableColumnType.Date;
    let parentesco = new BTableColumn("parentescoNombre", "Parentesco", false);
    let sexo = new BTableColumn("persona.sexo", "Genero");
    sexo.type = BTableColumnType.Custom;
    sexo.customFilter = Helpers.Filters.Sexo;

    let fechaInclusion = new BTableColumn("fechaInclusion", "Fecha de inclusión");
    fechaInclusion.type = BTableColumnType.Date;
    this.tableConfig.insertColumns(persona, cedula, fechaNacimiento, edad, parentesco, sexo, fechaInclusion);
  }
  activeTabMiembroAdd = 0;
  adding = false;
  miembroAddCedula: Miembro | undefined | null = null;
  miembroAddSinCedula: Miembro | undefined | null = null;
  showModalAddMiembro() {
    this.closeAdd();
    this.adding = true;
  }
  public async onAdd() {
    let ref = this.$refs.miembro_add_sin_cedula as any;
    let isValid = await ref.isValid();
    if (!isValid) return;

    let exist = false;

    exist = this.data.some(x => {
      let p = x.persona as Persona;
      let pm = (this.miembroAddSinCedula as Miembro).persona as Persona;
      if (p.noActNacimiento && p.noActNacimiento === pm.noActNacimiento)
        return true;

      if (
        p.nombre1 === pm.nombre1 &&
        p.apellido1 === pm.apellido1 &&
        p.nombre2 === pm.nombre2 &&
        p.apellido2 === pm.apellido2 &&
        (this.miembroAddSinCedula as Miembro).parentescoId === x.parentescoId
      )
        return true;

      return false;
    });
    if (exist) {
      this.operationNoAllowed(
        "La persona ya es parte de la composición familiar"
      );
      return;
    }

    this.$emit("add", this.miembroAddSinCedula);
    this.adding = false;
  }
  closeAdd() {
    this.adding = false;
    this.miembroAddCedula = null;
    this.miembroAddSinCedula = null;
  }
  editing = false;
  editingMiembro: Miembro | null = null;
  editingMiembroModel: Miembro | null = null;
  editingMiembroToSave!: Miembro;
  showModalEditMiembro(id: number, row: Miembro, props: RowTable<Miembro>) {
    this.editingMiembroModel = this.map<Miembro>(row);
    this.editingMiembro = this.map<Miembro>(row);
    this.editing = true;
  }
  public async editModelChange(value: Miembro) {
    this.editingMiembroToSave = value;
  }
  restartEdit() {
    this.editingMiembro = this.map<Miembro>(this.editingMiembroModel);
  }
  closeEdit() {
    this.editing = false;
    this.editingMiembro = null;
  }
  public async onEdit() {
    let ref = this.$refs.miembro_edit as any;
    if (ref) {
      let isValid = await ref.isValid();
      if (!isValid) return;
    }
    let value = this.editingMiembroToSave as Miembro;
    this.$emit("edit", value.id, value);
    this.editing = false;
  }
  public onCheck(list: Miembro[], current: Miembro) {
    this.$emit("check", list, current);
  }
  get headerTitle() {
    return this.title || "Listado de miembros";
  }
  get hasHogar() {
    return !!this.codigoHogar || !!this.hogarId;
  }
  get jefeHogar() {
    return this.data.find(
      x => x.parentescoCodigo === Helpers.Codes.Parentesco.JefeHogar
    );
  }

  getValueDate(value: string) {
    return moment(value).format("L");
  }
  onSelect(selected: Miembro, old: Miembro) {
    this.$emit("select", selected, old);
  }
  rowsChange(miembros: Miembro[]) {
    this.miembros = miembros;
    this.$emit("miembros", miembros);
  }
  onLoad(response: AxiosResponse) {
    this.data = response.data || [];
    this.$emit("total-miembros", this.data);
    this.$emit(
      "jefe-hogar",
      this.data.find(
        x => x.parentescoCodigo === Helpers.Codes.Parentesco.JefeHogar
      )
    );
    if (this.excluirJefe)
      this.tableConfig.data = this.tableConfig.data.filter(
        x => x.parentescoCodigo !== Helpers.Codes.Parentesco.JefeHogar
      );
  }

  @Watch("codigoHogar")
  onCodigoChange(
    value: string | undefined | null,
    old: string | undefined | null
  ) {
    if (!value) {
      this.miembros = [];
      this.data = [];
      this.$emit("jefe-hogar", undefined);
      return;
    }
    this.tableConfig.whereParams = this.getWhereParams();

    if (this.tableConfig.reload && old) this.tableConfig.reload();
  }

  @Watch("hogarId")
  onHogarIdChange(
    value: number | undefined | null,
    old: string | undefined | null
  ) {
    if (!value) {
      this.miembros = [];
      this.data = [];
      this.$emit("jefe-hogar", undefined);
      return;
    }
    this.tableConfig.whereParams = this.getWhereParams();

    if (this.tableConfig.reload && old) this.tableConfig.reload();
  }
}
